import ButtonIcon from "components/button-icon";
import Loading from "components/center-loading";
import ExpandableTableOptimization from "components/expandable-table-optimization";
import Header from "components/header";
import { IconFilterActive } from "components/icons/icn-filter-active.icon";
import { IconFilterInactive } from "components/icons/icn-filter-inactive.icon";
import { HistoryIcon, IconRefresh, OptimizationIcon, SendTransportIcon } from "components/icons/icn-index.icon";
import Input from "components/input";
import Pagination from "components/pagination";
import SnackBar from "material-ui/Snackbar";
import NextPageIcon from "material-ui/svg-icons/navigation/chevron-right";
import moment from "moment";
import PropTypes from "prop-types";
import { PureComponent } from "react";
import intl from "react-intl-universal";
import {
  getOptimizationsPaginatedService,
  getShipmentPriorityConfigurationService,
} from "services/optimizations/optimizations.service";
import { formatNumber } from "utils/format";
import Fetch from "utils/fetch";
import StorePersist from "utils/store-persist";
import { getLabels } from "./config-table";
import FilterOptimization from "./filterOptimization";
import ModalErroShipment from "./modal-erro-shipment/index";
import PriorityForm from "./prioridade-form/index";
import { ActionButtonsContainer, CodigoLink, StyledOptimization } from "./styledOptimization";

const SYSTEM_PLANNING_REGULAR = 0;
const SHIPMENT_PRIORITY_REGULAR = 1;
const SEQUENTIAL_PRIORITY_STEPS = [1, 2, 3, 4];

const SYSTEM_PLANNING_TYPES = [
  { Key: 0, Value: "Regular" },
  { Key: 1, Value: "Urgente" },
];

class Optimization extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      requestCount: 0,
      total: 0,
      currentPage: 0,
      qtRegsPerPage: 50,
      showHistory: false,
      otimizacoes: [],
      selectedItems: [],
      idsSelectedItems: [],
      selectedItem: null,
      allChecked: false,
      showFeedback: false,
      messageFeedback: "",
      filters: {
        OrderVolumeCodes: [],
        SourceIds: [],
        DestinationIds: [],
        MaterialGroupIds: [],
        MaterialNumbers: [],
        StatusId: null,
        StepId: null,
        FamilyIds: [],
        LabelFamilyIds: [],
        PickupDateFrom: "",
        PickupDateTo: "",
        DeliveryDateFrom: "",
        DeliveryDateTo: "",
        UpdatedDateFrom: "",
        UpdatedDateTo: "",
        HistoryView: false,
      },
      showFilter: false,
      showModalPrioridade: false,
      showModalErroShipment: false,
      errosShipments: [],
      systemPlanning: SYSTEM_PLANNING_REGULAR,
      systemPlanningTypes: SYSTEM_PLANNING_TYPES,
      shipmentPriority: SHIPMENT_PRIORITY_REGULAR,
      shipmentPriorityTypes: [],
      isShipmentPriorityEnabled: true,
      isSequentialPriorityEnabled: false,
      currentSequentialPriorityRound: 1,
      referenceCollectionDate: null,
    };
  }

  componentDidMount() {
    const showHistory = StorePersist.getValue("showHistoryOptimization") === "true";
    const currentPage = parseInt(
      StorePersist.getValue("currentPageOptimization") || "0",
      10
    );
    const filters = StorePersist.getValuesJSON(
      showHistory ? "filtersOptimizationHistory" : "filtersOptimization"
    );

    this.setState(
      {
        showHistory,
        ...(filters ? { filters } : {}),
      },
      () => {
        this.buscarConfiguracaoPrioridade();
        this.buscarOtimizacoes(currentPage);
      }
    );
  }

  buscarConfiguracaoPrioridade = async () => {
    try {
      const data = await getShipmentPriorityConfigurationService();
      this.setState({
        shipmentPriorityTypes: data?.ShipmentPriorityTypes || [],
        isShipmentPriorityEnabled: data?.IsShipmentPriorityEnabled || false,
        isSequentialPriorityEnabled: data?.IsSequentialPriorityEnabled || false,
      });
    } catch (e) {
      console.error("Erro ao buscar configuração de prioridade:", e);
    }
  };

  buscarOtimizacoes = async (page) => {
    this.handleFetch();

    const { qtRegsPerPage, currentPage, filters, showHistory } = this.state;
    const nextPage = page === undefined ? currentPage : page;

    StorePersist.setValue("currentPageOptimization", String(nextPage));

    const rawModel = {
      CountPage: qtRegsPerPage,
      Page: nextPage,
      OrderVolumeCodes: filters.OrderVolumeCodes,
      SourceIds: filters.SourceIds,
      DestinationIds: filters.DestinationIds,
      MaterialGroupIds: filters.MaterialGroupIds,
      MaterialNumbers: filters.MaterialNumbers,
      StatusId: filters.StatusId,
      StepId: filters.StepId,
      FamilyIds: filters.FamilyIds,
      LabelFamilyIds: filters.LabelFamilyIds,
      PickupDateFrom: filters.PickupDateFrom,
      PickupDateTo: filters.PickupDateTo,
      DeliveryDateFrom: filters.DeliveryDateFrom,
      DeliveryDateTo: filters.DeliveryDateTo,
      UpdatedDateFrom: filters.UpdatedDateFrom,
      UpdatedDateTo: filters.UpdatedDateTo,
      HistoryView: showHistory,
    };

    const model = Object.fromEntries(
      Object.entries(rawModel).filter(([, v]) =>
        !(Array.isArray(v) && v.length === 0) && v !== ""
      )
    );

    try {
      const data = await getOptimizationsPaginatedService(model);
      this.proccessData(data.Data);
      this.setState(
        {
          currentPage: nextPage,
          total: data.TotalRecordCount,
        },
        () => this.handleSelectAllItens(false)
      );
    } catch {
      this.showFeedback(intl.get("loadOptimization.thereErrorLoadingData"));
    }
    this.handleFetch(false);
  };

  proccessData = (data) => {
    this.setState({ otimizacoes: data });
  };

  handleFetch = (isFetching = true) => {
    this.setState((prevState) => ({
      requestCount: isFetching ? prevState.requestCount + 1 : prevState.requestCount - 1,
    }));
  };

  showFeedback = (message) => {
    this.setState({
      showFeedback: true,
      messageFeedback: message,
    });
  };

  getDateFormatted = (_value) =>
    _value ? moment(_value).format("L") : <div className="center-align">-</div>;

  getDateTimeFormatted = (_value) =>
    _value ? moment(_value).format("L LT") : <div className="center-align">-</div>;

  getNumberFormatted = (_value) => {
    const formattedValue = _value
      ? formatNumber(_value, {
          minimumFractionDigits: Number.isInteger(Number(_value)) ? 0 : 2,
          maximumFractionDigits: 2,
        })
      : "-";

    return <div className="center-align">{formattedValue}</div>;
  };

  getItemFormatted = (_value) => _value || <div className="center-align">-</div>;

  handleResolveValue = (key, item) => {
    if (item) {
      if (key === "DataColeta" || key === "DataEntrega") {
        return this.getDateFormatted(item[key]);
      }

      if (key === "UltimaAtualizacao") {
        return this.getDateTimeFormatted(item[key]);
      }

      if (key === "SaldoPendente" || key === "SaldoCancelado" || key === "Quantidade" || key === "QuantityConverted") {
        return this.getNumberFormatted(item[key]);
      }

      if (key === "Id" && item.Url && this.state.showHistory) {
        return (
          <CodigoLink
            className="column-codigo-link"
            onClick={() => this.props.history.push(item.Url)}
          >
            {item[key]}
          </CodigoLink>
        );
      }

      if (
        key === "SituacaoDesc" &&
        item["ErrosEnvioShipment"] &&
        item["ErrosEnvioShipment"].length > 0
      ) {
        return (
          <CodigoLink
            className="column-codigo-link column-alert-erro"
            onClick={() => this.openModalErroShipment(item["ErrosEnvioShipment"])}
          >
            {item[key]}
          </CodigoLink>
        );
      }

      return this.getItemFormatted(item[key]);
    }
  };

  openModalErroShipment = (errors) => {
    this.setState({
      errosShipments: errors,
      showModalErroShipment: true,
    });
  };

  handleResolveTitle = (key, item) => {
    if (!!item) {
      if (key === "SituacaoDesc") {
        return item["SituationFullDescription"];
      }
      if (["Material", "Fornecedor", "Destino"].includes(key)) {
        return item[key];
      }
    }
  };

  closeFeedback = () => {
    this.setState({ showFeedback: false });
  };

  showCheckbox = () => !this.state.showHistory;

  handleSelectItem = (selected, item) => {
    const { selectedItems, idsSelectedItems } = this.state;
    let items = [...selectedItems];
    let idsItens = [...idsSelectedItems];

    item.checked = selected;

    if (selected) {
      items.push(item);
      idsItens.push(item.Id);
    } else {
      items = items.filter((i) => i.Id !== item.Id);
      idsItens = idsItens.filter((i) => i !== item.Id);
    }

    this.setState({
      selectedItems: items,
      idsSelectedItems: idsItens,
    });
  };

  handleSelectAllItens = (checked) => {
    const { otimizacoes } = this.state;
    const items = [...otimizacoes];
    items.forEach((item) => {
      item.checked = checked;
    });
    const idsItens = checked ? items.map((item) => item.Id) : [];

    this.setState({
      selectedItems: checked ? items : [],
      idsSelectedItems: idsItens,
      allChecked: checked,
    });
  };

  searchFilters = (filters) => {
    StorePersist.setValuesJSON(
      this.state.showHistory ? "filtersOptimizationHistory" : "filtersOptimization",
      filters
    );
    this.showFilter();
    this.setState(
      {
        filters: filters,
        otimizacoes: [],
      },
      () => {
        this.buscarOtimizacoes(0);
      }
    );
  };

  verifyFilter = () => {
    const { showHistory } = this.state;
    const {
      IdOrigem,
      IdUnidadeNegocio,
      CodigoPedidoVolume,
      DataColetaDe,
      DataColetaAte,
      DataEntregaDe,
      DataEntregaAte,
      IdStatus,
      IdEtapa,
      NumeroMaterial,
      IdFamilia,
      IdFamiliaRotulada,
      DataAtualizacaoDe,
      DataAtualizacaoAte,
    } = this.state.filters;

    return Boolean(
      IdOrigem > 0 ||
        IdUnidadeNegocio > 0 ||
        CodigoPedidoVolume ||
        DataColetaDe ||
        DataColetaAte ||
        DataEntregaDe ||
        DataEntregaAte ||
        (showHistory && IdStatus && IdStatus > 0) ||
        (IdEtapa && IdEtapa > 0) ||
        NumeroMaterial ||
        (IdFamilia && IdFamilia > 0) ||
        (IdFamiliaRotulada && IdFamiliaRotulada > 0) ||
        (showHistory && DataAtualizacaoDe) ||
        (showHistory && DataAtualizacaoAte)
    );
  };

  showFilter = () => {
    this.setState((prevState) => ({
      showFilter: !prevState.showFilter,
    }));
  };

  showHistory = () => {
    this.setState(
      (prevState) => ({
        showHistory: !prevState.showHistory,
      }),
      () => {
        StorePersist.setValue("showHistoryOptimization", String(this.state.showHistory));
        this.buscarOtimizacoes(0);
      }
    );
  };

  changeValue = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  clearSelectedVolumes = () => {
    this.setState((prevState) => ({
      otimizacoes: prevState.otimizacoes.map((item) => ({
        ...item,
        checked: false,
      })),
      selectedItems: [],
      idsSelectedItems: [],
      allChecked: false,
    }));
  };

  getReferenceCollectionDateFromSelection = () => {
    const { selectedItems } = this.state;

    if (!Array.isArray(selectedItems) || selectedItems.length === 0) {
      return null;
    }

    const latestDate = selectedItems.reduce((currentMax, item) => {
      if (!item || !item.DataColeta) {
        return currentMax;
      }

      const currentDate = moment(item.DataColeta);

      if (!currentMax || currentDate.isAfter(currentMax)) {
        return currentDate;
      }

      return currentMax;
    }, null);

    return latestDate ? latestDate.toDate() : null;
  };

  handleResetSequentialPriority = () => {
    this.clearSelectedVolumes();
    this.setState({
      currentSequentialPriorityRound: 1,
      referenceCollectionDate: null,
      shipmentPriority: SHIPMENT_PRIORITY_REGULAR,
    });
  };

  sendTransport = () => {
    try {
      if (!(Array.isArray(this.state.idsSelectedItems) && this.state.idsSelectedItems.length))
        this.showFeedback(intl.get("loadOptimization.selectLeastOneVolumeSend"));
      else if (
        this.state.isSequentialPriorityEnabled &&
        this.state.currentSequentialPriorityRound > 1 &&
        !this.state.referenceCollectionDate
      ) {
        this.showFeedback(intl.get("transports.otimizationCharge.actions.sequentialReferenceMissing"));
      } else this.openCloseSolicitacaoPrioridade(true);
    } catch (err) {
      console.log("err", err);
    }
  };

  openCloseSolicitacaoPrioridade = (value) => {
    this.setState({
      showModalPrioridade: value,
    });
  };

  openCloseModalErroShipment = (value) => {
    this.setState({
      showModalErroShipment: value,
    });
  };

  enviarParaTransporte = async () => {
    this.handleFetch();

    const currentPriorityRound = this.state.isSequentialPriorityEnabled
      ? this.state.currentSequentialPriorityRound
      : this.state.shipmentPriority;

    const model = {
      IdVolumes: this.state.idsSelectedItems,
      SystemPlanning: this.state.systemPlanning,
      ShipmentPriority: currentPriorityRound,
      PriorityRound: this.state.isSequentialPriorityEnabled ? currentPriorityRound : null,
      ReferenceCollectionDate: this.state.isSequentialPriorityEnabled ? this.state.referenceCollectionDate : null,
    };

    try {
      const response = await Fetch.post(`volumeoptimization/enviarParaTransporte`, model);
      const result = response?.data || {};

      if (this.state.isSequentialPriorityEnabled) {
        const referenceCollectionDate = result.ReferenceCollectionDate
          ? moment(result.ReferenceCollectionDate).toDate()
          : (this.state.referenceCollectionDate || this.getReferenceCollectionDateFromSelection());
        const nextPriorityRound = result.IsSequentialFlowCompleted
          ? 1
          : (result.NextPriorityRound || Math.min(currentPriorityRound + 1, 4));

        this.setState({
          currentSequentialPriorityRound: nextPriorityRound,
          referenceCollectionDate: result.IsSequentialFlowCompleted ? null : referenceCollectionDate,
          shipmentPriority: nextPriorityRound,
        });
      }

      this.clearSelectedVolumes();
      this.openCloseSolicitacaoPrioridade(false);
      this.buscarOtimizacoes(0);
    } finally {
      this.handleFetch(false);
    }
  };

  render() {
    const {
      showHistory,
      otimizacoes,
      messageFeedback,
      requestCount,
      showFeedback,
      currentPage,
      qtRegsPerPage,
      total,
      filters,
      showFilter,
      showModalPrioridade,
      showModalErroShipment,
      systemPlanning,
      systemPlanningTypes,
      shipmentPriority,
      shipmentPriorityTypes,
      isShipmentPriorityEnabled,
      isSequentialPriorityEnabled,
      currentSequentialPriorityRound,
      referenceCollectionDate,
      allChecked,
      errosShipments,
    } = this.state;

    return (
      <StyledOptimization
        className={isSequentialPriorityEnabled && !showHistory ? "sequential-priority-active" : ""}
      >
        <Loading isLoading={requestCount > 0} />
        <Header title={intl.get("transports.otimizationCharge.header.title")} titleWidth={450}>
          <div className="buttons-header-container">
            <div className="filterContainer">
              <ButtonIcon
                onClick={this.showFilter}
                buttonType="secondary"
                buttonText={intl.get("filters.filter")}
                buttonIcon={this.verifyFilter() ? <IconFilterActive /> : <IconFilterInactive />}
                className={"button-filter"}
              />
            </div>
          </div>
        </Header>

        <ActionButtonsContainer>
          <div className="action-left-column">
            {isSequentialPriorityEnabled && !showHistory && (
              <div className="sequential-priority-container">
                <div className="sequential-priority-main-row">
                  <div className="sequential-priority-left-column">
                    <div
                      className="sequential-priority-flow"
                      aria-label={intl.get("transports.otimizationCharge.actions.sequentialFlowAriaLabel")}
                    >
                      {SEQUENTIAL_PRIORITY_STEPS.map((step, index) => (
                        <span key={step} className="sequential-priority-step-wrapper">
                          <span
                            className={`sequential-priority-step ${
                              currentSequentialPriorityRound === step ? "sequential-priority-step-active" : ""
                            }`}
                          >
                            P{step}
                          </span>
                          {index < SEQUENTIAL_PRIORITY_STEPS.length - 1 && (
                            <span className="sequential-priority-arrow" aria-hidden="true">
                              <NextPageIcon />
                            </span>
                          )}
                        </span>
                      ))}
                    </div>

                    <div className="sequential-priority-description">
                      {intl.get("transports.otimizationCharge.actions.sequentialFlowDescription")}
                    </div>
                  </div>

                  <div className="sequential-priority-reference-column">
                    <div className="sequential-priority-reference">
                      <Input
                        name="referenceCollectionDate"
                        label={intl.get("transports.otimizationCharge.actions.sequentialReferenceDate")}
                        value={referenceCollectionDate ? moment(referenceCollectionDate).format("L") : ""}
                        readOnly
                        disabled
                      />
                    </div>

                    <ButtonIcon
                      buttonType="secondary"
                      buttonIcon={<IconRefresh width="18px" height="18px" />}
                      buttonText={intl.get("transports.otimizationCharge.actions.resetSequentialPriority")}
                      className="sequential-priority-reset"
                      onClick={this.handleResetSequentialPriority}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="action-right-column">
            {!showHistory && (
              <div className="filterContainer">
                <ButtonIcon
                  buttonType="primary"
                  buttonIcon={SendTransportIcon({ width: "20px", height: "20px", color: "#fff" })}
                  buttonText={intl.get("transports.otimizationCharge.actions.sendToTransport")}
                  className="button-filter-vision-sendToTransport"
                  onClick={this.sendTransport}
                />
              </div>
            )}

            <div className="filterContainer">
              <ButtonIcon
                buttonType={"secondary"}
                buttonIcon={
                  showHistory ? (
                    <OptimizationIcon style={{ width: 20, height: 20 }} />
                  ) : (
                    <HistoryIcon style={{ width: 20, height: 20 }} />
                  )
                }
                buttonText={
                  showHistory
                    ? intl.get("transports.otimizationCharge.actions.alternateToOtimization")
                    : intl.get("transports.otimizationCharge.actions.alternateToHistoric")
                }
                className="button-filter-vision-alternateToHistoric"
                onClick={this.showHistory}
              />
            </div>
          </div>
        </ActionButtonsContainer>

          <FilterOptimization
            showFilter={showFilter}
            useFilterDefault={this.state.useFilterDefault}
            initialData={filters}
            handleClose={this.searchFilters}
            triggerClose={this.showFilter}
            showHistory={showHistory}
          />

        <div className="content">
          {otimizacoes.length && requestCount === 0 ? (
            <div className="content-internal">
              <ExpandableTableOptimization
                data={otimizacoes}
                labelsList={getLabels(showHistory)}
                labelKey="Label"
                childrenKey="Pedidos"
                onClickItem={this.handleClick}
                onSelectItem={this.handleSelectItem}
                allChecked={allChecked}
                onSelectAllItens={this.handleSelectAllItens}
                resolveValue={this.handleResolveValue}
                resolveTitle={this.handleResolveTitle}
                showCheckbox={this.showCheckbox}
              />
              <div className="optimization-pagination">
                <Pagination
                  page={currentPage}
                  pageSize={qtRegsPerPage}
                  amount={total}
                  refreshSearch={this.buscarOtimizacoes}
                  backgroundColor={"#f2f2f2"}
                />
              </div>
            </div>
          ) : (
            <div>{intl.get("loadOptimization.noRecordsFound")}</div>
          )}
        </div>

        {showModalPrioridade && (
          <PriorityForm
            open={showModalPrioridade}
            systemPlanning={systemPlanning}
            systemPlanningTypes={systemPlanningTypes}
            shipmentPriority={shipmentPriority}
            shipmentPriorityTypes={shipmentPriorityTypes}
            isShipmentPriorityEnabled={isShipmentPriorityEnabled}
            isSequentialPriorityEnabled={isSequentialPriorityEnabled}
            currentSequentialPriorityRound={currentSequentialPriorityRound}
            changeValue={this.changeValue}
            handleSend={this.enviarParaTransporte}
            handleClose={this.openCloseSolicitacaoPrioridade}
          />
        )}

        {showModalErroShipment && (
          <ModalErroShipment
            open={showModalErroShipment}
            errors={errosShipments}
            handleClose={this.openCloseModalErroShipment}
          />
        )}

        <SnackBar
          message={messageFeedback}
          open={showFeedback}
          autoHideDuration={3000}
          onRequestClose={this.closeFeedback}
        />
      </StyledOptimization>
    );
  }
}

Optimization.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default Optimization;
